import React, { memo } from "react";
import styled from "styled-components";
import color from "../../../helpers/color";
import Label from "../../Data/Label";
import { useScope } from "./state/scope";
const Root = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-m26uxc-0"
})(["position:absolute;top:", "px;left:0;bottom:-2px;"], ({
  top
}) => top !== undefined ? top : -2));
const StyledLabel = /*#__PURE__*/styled(Label).withConfig({
  displayName: "StyledLabel",
  componentId: "sc-m26uxc-1"
})(["position:absolute;z-index:3;top:15px;left:50%;width:70px;background-color:", ";color:white;font-size:14px;line-height:24px;text-align:center;transform:translateX(-50%);"], color);
const Range = /*#__PURE__*/memo(({
  top,
  color,
  length,
  style,
  position,
  children
}) => {
  const scope = useScope();
  const displayLength = Math.max(0, Math.min(scope.length, length, scope.end - position));
  return /*#__PURE__*/React.createElement(Root, {
    top: top,
    style: {
      width: `${displayLength / scope.length * 100}%`,
      left: `${(position - scope.start) / scope.length * 100}%`,
      ...style
    }
  }, children && /*#__PURE__*/React.createElement(StyledLabel, {
    inverted: true,
    color: color
  }, children));
});
Range.defaultProps = {
  color: "default"
};
export default Range;
//# sourceMappingURL=Label.js.map